module.exports = __webpack_public_path__ + "static/carlos-gallardo-e89bd44ae4170994c02abd04525f5f50.png";